module.exports = __webpack_public_path__ + "img/onboarding-steps.5e66679f.svg";